import React from 'react';
import {fieldsConfig} from '../../Profile/profile.constants';
import {
  View,
  Text,
  StyleSheet,
  TextInput,
  Platform,
  TouchableOpacity,
} from 'react-native';
import Colors from '../../../assets/Color/Colors';
import {Color, globalFontStyle} from '../../../assets';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

const D24WithDrawBankDetails = () => {
  const [fieldsConfig, setFieldsConfig] = useState([]);
  let userInfo = useSelector(({profile}) => profile.profileData);

  useEffect(() => {
    setFieldsConfig(userInfo?.withdrawConfig?.pg?.[1]?.fields);
  }, [userInfo]);

  return (
    <View>
      <View style={styles.eventDetailsBox}>
        <View>
          {fieldsConfig.map((item, key) => {
            let dependents =
              item?.dependents?.[item.value]?.fields ??
              item?.dependents?.all?.fields;
            return (
              <>
                {dependents ? (
                  <View key={item?.label}>
                    <FormTextLabel
                      labelStyles={[
                        {
                          width: 90,
                        },
                        styles.text_input,
                      ]}
                      label={item?.label}
                    />
                    <View style={styles.inputDiv}>
                      <TextInput
                        style={styles.input}
                        value={item?.value}
                        editable={false}
                      />
                    </View>
                  </View>
                ) : null}
                {dependents?.map(item1 => {
                  return (
                    <View key={item1?.label}>
                      <FormTextLabel
                        labelStyles={[
                          {
                            width: 90,
                          },
                          styles.text_input,
                        ]}
                        label={item1?.label}
                      />
                      <View style={styles.inputDiv}>
                        <TextInput
                          style={styles.input}
                          value={item1?.value}
                          editable={false}
                        />
                      </View>
                    </View>
                  );
                })}
              </>
            );
          })}
        </View>
      </View>
    </View>
  );
};
export default D24WithDrawBankDetails;

const styles = StyleSheet.create({
  input: {
    height: 40,
    borderWidth: 0,
    padding: 5,
    flex: 1,
    color: Colors.black,
  },
  text_input: {
    zIndex: 10,
    textAlign: 'center',
    color: Colors.lightgrey,
    ...globalFontStyle.appFontSubText,
    position: 'relative',
    backgroundColor: Colors.bgWhite,
    top: 10,
    left: 20,
  },
  inputDiv: {
    flexDirection: 'row',
    marginBottom: 8,
    paddingLeft: 5,
    borderRadius: 8,
    alignItems: 'center',
    borderColor: Colors.borderColor,
    borderWidth: 1,
  },
  successText: {
    ...globalFontStyle.appFontSmallText,
    color: '#00aa51',
  },
  eventDetailsBox: {
    //borderWidth: 0.75,
    //borderColor: Color.borderColor,
    borderRadius: 8,
  },
  eventDetailTitle: {
    paddingVertical: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: '#FF0000',
  },
});
